/*
 * Respuestas del staff de MU VANGUARD a los pendientes de la guía.
 * Se muestran como "Confirmado por administración" con su fecha. Son distintas de
 * "Confirmado por configuración" (archivos del 08/10/2026) y de "Comprobado dentro del juego".
 *
 * Cada respuesta confirma SOLO el dato de su `pendingKey`. Por ejemplo, la ubicación de Sebina
 * (npc-location:235) no confirma el Zen ni los requisitos de su misión.
 *
 * Formato de `pendingKey`: el mismo que muestra "Copiar todos los pendientes de la guía".
 */

export type AdminConfirmation = {
  pendingKey: string
  /** Respuesta tal como la dio la administración. */
  answer: string
  /** Fecha de la confirmación, AAAA-MM-DD. */
  date: string
  /** Datos estructurados cuando la respuesta es una ubicación. */
  location?: { mapName: string; x?: number; y?: number }
  /** Varias ubicaciones (p. ej. un NPC que se desplaza), con su condición. */
  locations?: { mapName: string; x?: number; y?: number }[]
  condition?: string
  by?: string
}

const ROBOT = 'Robot (805): una ubicación por ciudad, cada uno con su propia tienda'
export const adminConfirmations: AdminConfirmation[] = [
  { pendingKey: 'npc-location:805:lorencia', answer: 'Robot en Lorencia 131, 122 · vende sets de DK, DW, MG y RF', date: '2026-10-11', location: { mapName: 'Lorencia', x: 131, y: 122 }, by: ROBOT },
  { pendingKey: 'npc-location:805:devias', answer: 'Robot en Devias 196, 50 · vende lo mismo que el de Lorencia', date: '2026-10-11', location: { mapName: 'Devias', x: 196, y: 50 }, by: ROBOT },
  { pendingKey: 'npc-location:805:noria', answer: 'Robot en Noria 107, 109 · vende cosas de elfa', date: '2026-10-11', location: { mapName: 'Noria', x: 107, y: 109 }, by: ROBOT },
  { pendingKey: 'npc-location:805:elbeland', answer: 'Robot en Elbeland 38, 216 · vende cosas de summoner', date: '2026-10-11', location: { mapName: 'Elbeland', x: 38, y: 216 }, by: ROBOT },
]

export const adminConfirmation = (key: string) => adminConfirmations.find((c) => c.pendingKey === key)

export const formatAdminDate = (iso: string) => {
  const d = new Date(`${iso}T12:00:00`)
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' })
}
